import React from "react";
import PageHeader from "../PageHeader"; // Import the component
import ServicesSection from "../Services"; // Your existing About Section
import heroBackImage from "../images/cta/office-bg.webp"; // Import the background image you want
import Faqs from "../Faqs";
const AboutPage = () => {
  
  // 1. Define the breadcrumb path
  const breadcrumbLinks = [
    { label: "الرئيسية", path: "/" },
    { label: "خدماتنا", path: "/services" } // The last one is the active page
  ];

  return (
    <>
      {/* 2. Use the Component */}
      <PageHeader 
        title="خدماتنا" 
        bgImage={heroBackImage} 
        breadcrumbs={breadcrumbLinks} 
      />

      {/* The rest of your page content */}
      <ServicesSection />
      <Faqs />
    </>
  );
};

export default AboutPage;